export * from './image-gallery.component';
export * from './image-gallery.module';
